// Permisos RBAC del catálogo de reportes. Son DOS y separados: `list` abre la pantalla y el item
// del sidebar; `run` autoriza generar el archivo. Tener uno no implica el otro.

/** Van como `string`: `PermissionKey`, generado del OpenAPI, no expone claves de dominio. */
export const REPORTS_PERMISSIONS = {
    list: 'retail.report.list',
    run: 'retail.report.run',
} as const;

export type ReportsPermissionKey = (typeof REPORTS_PERMISSIONS)[keyof typeof REPORTS_PERMISSIONS];

export interface ReportsAbilities {
    canList: boolean;
    canRun: boolean;
}

/**
 * Toma el set como `ReadonlySet<string>` —y no como `PermissionKey`— porque el union generado del
 * OpenAPI no incluye las claves de dominio: comparar contra él no compila.
 */
export function resolveReportsAbilities(grantedPermissions: ReadonlySet<string>): ReportsAbilities {
    return {
        canList: grantedPermissions.has(REPORTS_PERMISSIONS.list),
        canRun: grantedPermissions.has(REPORTS_PERMISSIONS.run),
    };
}
